import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { PreloadAllModules, provideRouter, withComponentInputBinding, withPreloading, withViewTransitions } from '@angular/router';
import { provideStore } from '@ngrx/store';
import { provideNgxMask } from 'ngx-mask';
import { provideToastr } from 'ngx-toastr';
import { appRoutes } from './app.routes';
import { authInterceptor } from './core/auth/auth.interceptor';
import { apiErrorInterceptor } from './core/http/api-error.interceptor';
import { retryInterceptor } from './core/http/retry.interceptor';
import { OidcSessionProvider } from './core/auth/oidc-session-provider';
import { SESSION_PROVIDER } from './core/auth/session-provider';
import { ChurchTimeService } from './core/time/church-time.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes, withPreloading(PreloadAllModules), withViewTransitions(), withComponentInputBinding()),
    provideAnimations(),
    provideAnimationsAsync(),
    // Order is the contract: a request passes outward-in, a failure travels back inward-out.
    // retryInterceptor sits last so it is nearest the network and absorbs a dropped read before
    // apiErrorInterceptor ever sees it; only a failure that survived its retries gets reported.
    provideHttpClient(withInterceptors([authInterceptor, apiErrorInterceptor, retryInterceptor])),
    provideStore(),
    provideNgxMask(),
    provideToastr({ positionClass: 'toast-bottom-right' }),
    { provide: SESSION_PROVIDER, useExisting: OidcSessionProvider },
    // Fetch the church time zone before the first screen renders, so no view ever paints a time
    // in the fallback zone and then silently corrects itself. The service swallows failure, so a
    // config endpoint that is down delays startup briefly rather than blocking it.
    provideAppInitializer(() => inject(ChurchTimeService).load()),
  ],
};
